// extracted by mini-css-extract-plugin
module.exports = {"contents":"Ti","sectionHeading":"Ui"};